import { useCallback, useRef, useState } from "react";

/** Lock immediately, including multiple invocations before React re-renders. */
export function usePendingAction() {
  const locked = useRef(false);
  const [isPending, setIsPending] = useState(false);
  const run = useCallback(async <T>(action: () => Promise<T>) => {
    if (locked.current) return;
    locked.current = true;
    setIsPending(true);
    try {
      return await action();
    } finally {
      locked.current = false;
      setIsPending(false);
    }
  }, []);
  return { isPending, run };
}
